"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountAchievementSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
exports.AccountAchievementSchema = zod_1.z.object({
  /** Дата начала отсчёта */
  created_at: zod_1.z.string().datetime().or(zod_1.z.date()),
  achievement: zod_1.z.nativeEnum(lingo2_models_1.UserAchievementEnum),
  /** Значение показателя, если предусмотрено */
  value: zod_1.z.number().optional()
});
